<template>
  <v-form id="login-form" ref="form">
    <v-card flat color="transparent">
      <v-card-title>
        <span class="headline text-capitalize">{{ type }}</span>
      </v-card-title>
      <v-col v-if="type == 'register'" cols="12">
        <v-text-field
          v-model="firstname"
          :rules="nameRules"
          :counter="20"
          label="First name"
          required
        ></v-text-field>
      </v-col>
      <v-col v-if="type == 'register'" cols="12">
        <v-text-field
          v-model="lastname"
          :rules="nameRules"
          :counter="20"
          label="Last name"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="password"
          :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :passwordRules="[passwordRules.required, passwordRules.min]"
          :type="passwordShow ? 'text' : 'password'"
          name="input-10-1"
          label="Password"
          hint="At least 8 characters"
          counter
          @click:append="passwordShow = !passwordShow"
        ></v-text-field>
      </v-col>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.prevent="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import firebase from "firebase";

export default {
  props: ["type"],
  data: () => ({
    valid: false,
    firstname: "",
    lastname: "",
    nameRules: [v => !!v || "Name is required"],
    email: "",
    emailRules: [v => !!v || "Name is required"],
    password: "",
    passwordShow: false,
    passwordRules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    }
  }),
  methods: {
    submit: function() {
      if (this.type === "login") this.loginUser();
      else if (this.type === "register") this.newUser();
    },
    newUser: function() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.form.name
            })
            .then(cred => {
              alert(cred);
            });
        })
        .catch(err => {
          this.error = err.message;
        });
      this.reset();
    },
    logoutUser: function() {
      firebase.auth().signOut();
    },
    loginUser: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(() => {})
        .catch(err => {
          this.error = err.message;
        });
      this.reset();
    },
    reset() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
